import CreateTodo from './Component/CreateTodo';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function App() {
    return (
    <div>
      <CreateTodo />
      </div>
  )
}
